<ng-template #titleContent>
  <div class="text-e-dark-green flex grow flex-col"  [ngClass]="{' md:basis-[4.375rem]': !disableShowRecipeAction}">
    <div class="font-[700] text-[1rem]">{{_recipe?.displayname}}</div>
    <div class="flex flex-row flex-wrap justify-between gap-1">
      <div class="text-[0.875rem]">{{_recipe?.subtitle}}</div>
      @if (_recipe?.label) {
      <span class="flex flex-row justify-end flex-grow">
        <span class= "bg-e-orange text-white rounded-full px-2 py-0.5 text-sm whitespace-nowrap">{{_recipe?.label}}</span>
      </span>
      }
    </div>
  </div>
</ng-template>

<ng-template #titleBlock>
  @if (!disableShowRecipeAction) {
    <ng-container *ngTemplateOutlet="titleContent" (click)="showRecipeAction()"></ng-container>
  }@else {
    <a target="_blank" [href]="_recipe?.recipeurl">
      <ng-container *ngTemplateOutlet="titleContent"></ng-container>
    </a>
  }
</ng-template>

<ng-template #chipsBlock>
  <div class="gap-2 flex flex-row overflow-x-auto">
    <app-chip>
      <time class="text-[0.75rem]">{{_recipe?.cookingtime}} {{'common.minutes_abbr' | translate}}</time>
    </app-chip>
    @if (getCalories(_recipe)) {
    <app-chip>
      <span class="text-[0.75rem]">{{getCalories(_recipe)}} {{'unit_abbr.KILOCALORIES' | translate}}</span>
    </app-chip>
    }
    <app-chip>
      <span class="text-[0.75rem]">{{_recipe?.vegetableweight |translate}} {{'unit_abbr.GRAM' |translate}} {{'recipe.vegetableweight'| translate}}</span>
    </app-chip>
  </div>
</ng-template>

<ng-template #lifestylesBlock let-class="class">
  @if (_recipe.lifestyles && _recipe.lifestyles.length > 0) {
  <div class="flex flex-row flex-wrap content-start items-start {{class}}">
    @for (lifestyle of _recipe.lifestyles; track $index; let last = $last) {
    {{getLifestyle(lifestyle?.lifestyleid)?.name | capitalizefirst}}@if (!last){, }
    }
  </div>
  }
</ng-template>

<ng-template #buttonsBlock>
  <div class="flex flex-col">
    <div class="flex flex-row gap-[0.5rem]">
      @switch (_status) {
      @case ('PROCESSED') {
      @if (disableShowRecipeAction) {
      <a target="_blank" [href]="_recipe?.recipeurl"
        class="button-base bg-e-reg-green text-e-dark-green w-full rounded-full md:w-1/2 h-[2rem] flex flex-col justify-center font-[600] text-[0.75rem] lowercase hover:bg-e-dark-green hover:text-e-reg-green ">{{'recipe.show_recipe'
        | translate}}</a>
      }@else {
      <a (click)="showRecipeAction()"
        class="button-base bg-e-reg-green text-e-dark-green w-full rounded-full md:w-1/2 h-[2rem] flex flex-col justify-center font-[600] text-[0.75rem] lowercase hover:bg-e-dark-green hover:text-e-reg-green">{{'recipe.show_recipe'
        | translate}}</a>
      }
      }
      @case ('ONBOARD') {
      @if (disableShowRecipeAction) {
      <a target="_blank" [href]="_recipe?.recipeurl"
        class="button-base bg-e-white text-e-dark-green w-full rounded-full md:w-1/2 h-[2rem] flex flex-col justify-center font-[600] text-[0.75rem] lowercase hover:bg-e-light-green">{{'recipe.show_recipe'
        | translate}}</a>
      }@else {
      <a (click)="showRecipeAction()"
        class="button-base bg-e-white text-e-dark-green w-full rounded-full md:w-1/2 h-[2rem] flex flex-col justify-center font-[600] text-[0.75rem] lowercase hover:bg-e-light-green">{{'recipe.show_recipe'
        | translate}}</a>
      }
      <a [routerLink]="['/personalmenu']" class="button-base w-full rounded-full bg-e-orange text-white hover:bg-e-light-green hover:text-e-dark-green">{{'recipe.order'
        |translate}}</a>
      }
      @case ('SELECTABLE') {
      <button [disabled]="loading" (click)="toggleSelection()" class="mr-2.5 w-full rounded-md md:w-3/5"
        [ngClass]="{'button-light' : _selected, 'button-mid text-e-mid-green bg-e-dark-green': !_selected}">
        {{(_selected? 'recipe.chosen': 'recipe.choose') | translate}}
      </button>
      @if (disableShowRecipeAction) {
      <a target="_blank" [href]="_recipe?.recipeurl" class="button-mid my-auto w-full rounded-md text-center md:w-2/5"><small>{{'recipe.more_info' | translate}}</small></a>
      }@else {
      <button (click)="showRecipeAction()" class="button-clear w-full rounded-md md:w-2/5">{{'recipe.more_info' | translate}}</button>
      }
      }
      @case ('PERSONEDITABLE') {
      <app-personselection-compact [persons]="persons" class="w-full md:w-1/2" (personsChange)="changePersons($event)" [boldNumber]="true">
        <span>{{'common.portions_unit'|translate : {count: _recipe?.doublepersons? persons * 2 : persons } }}</span>
      </app-personselection-compact>
      <button [disabled]="loading" (click)="toggleSelection()"
        class="w-full md:w-1/2 rounded-full py-0 h-[2.0625rem] flex flex-col justify-center font-[600] text-[0.75rem] lowercase"
        [ngClass]="{'button-mid' : _selected, 'button-cta': !_selected}">
        @if (_selected) {
        {{'recipe.added' | translate}}
        } @else {
        + {{'recipe.add' | translate}}
        }
      </button>
      }
      @default {}
      }
    </div>
  </div>
</ng-template>

<div class="{{scheme[colorscheme]}} flex w-full flex-col items-stretch rounded-xl">
  <div class="relative">
    @if(overlappingAllergens()?.length > 0){
    <span class="absolute top-4 left-4 rounded-full bg-e-gold text-white px-3 py-1">
      {{'common.contains' | translate}}
      @for (allergen of overlappingAllergens(); track $index; let last = $last) {
      {{'allergen.' + allergen | translate | lowercase}} @if (!last) {,}
      }
    </span>
    }

    <!-- @if (_recipe?.salessurcharge && calculatedPrice && _recipe?.salessurcharge > 0) {
    <span class="absolute bottom-[15px] left-[15px] rounded-full bg-e-orange text-e-white px-3 py-1 font-sans">
      +{{calculatedPrice?.priceincvat |currency: 'EUR':'symbol':'.2-2':'nl'}} {{'common.pp_abbr'| translate}}
    </span>
    } -->

    @if (!disableShowRecipeAction) {
    <app-image size="md" (click)="showRecipeAction()" [imageobject]="_recipe" alt="{{_recipe?.displayname}}" class="w-full cursor-pointer object-cover object-top rounded-[0.75rem_0.75rem_0rem_0rem] {{featured ? 'h-[14rem]' : 'h-[12.5rem]'}}"></app-image>
    }@else{
    <a target="_blank" [href]="_recipe?.recipeurl">
      <app-image size="md" [imageobject]="_recipe" alt="{{_recipe?.displayname}}"class="w-full object-cover object-top rounded-[0.75rem_0.75rem_0rem_0rem] {{featured ? 'h-[14rem]' : 'h-[12.5rem]'}}"></app-image>
    </a>
    }
  </div>

  <div class="px-[1rem] pt-[0.625rem] pb-[1rem] flex h-full flex-col justify-between">
    @if (featured) {
    <div class="flex xl:flex-row flex-col flex-grow">
      <div class="w-full xl:w-1/2 flex flex-col gap-[0.5rem] pr-0 xl:pr-[1.25rem]">
        <ng-container *ngTemplateOutlet="titleBlock"></ng-container>
        <div class="order-2 xl:order-1 xl:mb-0 mb-[0.5rem]">
          <ng-container *ngTemplateOutlet="lifestylesBlock; context: {class: 'text-[0.875rem]'}"></ng-container>
        </div>
        @if (!condensed) {
        <div class="order-1 xl:order-2">
          <ng-container *ngTemplateOutlet="chipsBlock"></ng-container>
        </div>
        }
      </div>
      <div class="w-full xl:w-1/2 flex flex-col gap-[0.5rem] justify-end pl-0 xl:pl-[1.25rem]">
        @if (!condensed) {
        <ng-container *ngTemplateOutlet="buttonsBlock"></ng-container>
        }
      </div>
    </div>
    }@else {
    <div class="flex flex-col gap-[0.5rem] mb-[0.5rem]">
      <ng-container *ngTemplateOutlet="titleBlock"></ng-container>
      @if (!condensed) {
      <ng-container *ngTemplateOutlet="chipsBlock"></ng-container>
      <ng-container *ngTemplateOutlet="lifestylesBlock; context: {class: 'min-h-[1.3125rem] text-[0.875rem]'}"></ng-container>
      }
    </div>
    @if (!condensed) {
    <ng-container *ngTemplateOutlet="buttonsBlock"></ng-container>
    }
    }
  </div>
</div>